"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const default_1 = __importDefault(require("../layouts/default"));
const seo_1 = __importDefault(require("../components/seo"));
const utils_1 = require("../utils");
var IndexPage = function IndexPage(_ref) {
    var data = _ref.data;
    // all posts without dates are assumed to be drafts or pages
    // not to be added to postsList
    var posts = data.allMarkdownRemark.edges.filter(function (p) {
        var _p$node, _p$node$frontmatter;
        return (p === null || p === void 0 ? void 0 : (_p$node = p.node) === null || _p$node === void 0 ? void 0 : (_p$node$frontmatter = _p$node.frontmatter) === null || _p$node$frontmatter === void 0 ? void 0 : _p$node$frontmatter.date) != null;
    });
    var postsListContainer = utils_1.groupBy(posts, utils_1.getDateYear).map(function (_ref2, i) {
        var year = _ref2.year, posts = _ref2.posts;
        return /*#__PURE__*/ react_1.default.createElement("div", {
            key: i
        }, /*#__PURE__*/ react_1.default.createElement("h4", {
            className: "code"
        }, year), postsList(posts));
    }).reverse();
    return /*#__PURE__*/ react_1.default.createElement(default_1.default, null, /*#__PURE__*/ react_1.default.createElement(seo_1.default, {
        title: "Home"
    }), /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("ul", null, postsListContainer)));
};
function postsList(posts) {
    return posts.map(function (post) {
        var _post$node, _post$node$frontmatte, _post$node2, _post$node2$fields, _post$node3, _post$node3$frontmatt;
        return /*#__PURE__*/ react_1.default.createElement("li", {
            key: post.node.id
        }, /*#__PURE__*/ react_1.default.createElement("div", {
            className: "post-date code"
        }, /*#__PURE__*/ react_1.default.createElement("small", null, post === null || post === void 0 ? void 0 : (_post$node = post.node) === null || _post$node === void 0 ? void 0 : (_post$node$frontmatte = _post$node.frontmatter) === null || _post$node$frontmatte === void 0 ? void 0 : _post$node$frontmatte.date)), /*#__PURE__*/ react_1.default.createElement("div", {
            className: "title"
        }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
            to: (post === null || post === void 0 ? void 0 : (_post$node2 = post.node) === null || _post$node2 === void 0 ? void 0 : (_post$node2$fields = _post$node2.fields) === null || _post$node2$fields === void 0 ? void 0 : _post$node2$fields.slug) || ''
        }, (post === null || post === void 0 ? void 0 : (_post$node3 = post.node) === null || _post$node3 === void 0 ? void 0 : (_post$node3$frontmatt = _post$node3.frontmatter) === null || _post$node3$frontmatt === void 0 ? void 0 : _post$node3$frontmatt.title) || '')));
    });
}
exports.default = IndexPage;
var pageQuery = "1609438245";
